const TIER_NAMES = {
  GUEST: 'guest',
  DEFAULT: 'softSignedIn',
  SOFT_SIGNED_IN: 'softSignedIn',
  NON_LOYALIST: 'NON-LOYALIST',
  BASE: 'base',
  TOL: 'tol',
  UNL: 'unl',
};

const TIER_ICONS = {
  [TIER_NAMES.GUEST]: 'loyallist-large',
  [TIER_NAMES.NON_LOYALIST]: 'loyallist-large',
  [TIER_NAMES.TOL]: 'loyallist-large-black',
  [TIER_NAMES.UNL]: 'loyallist-key-large',
  [TIER_NAMES.BASE]: 'loyallist-large',
};

const TIER_HRESHOLD = {
  REWARD: 3000,
  BASE: 1500,
  TOL: 3500,
};

const LOYALTY_STATES = {
  GUEST: 'guest',
  SOFT_SIGNED_IN: 'Soft_SignedIn',
  NON_LOYALIST: 'nonLoyalist',
  CLOSE_TO_NEXT_TIER: 'closeToNextTier',
  CLOSE_TO_REWARD: 'closeToReward',
  NOT_CLOSE_TO_REWARD: 'notCloseToReward',
  NO_POINTS_NO_REWARDS: 'noPointsNoRewards',
  HAVE_REWARDS_MONEY: 'signedInHasRewardsMoney',
};

export { TIER_NAMES, TIER_ICONS, TIER_HRESHOLD, LOYALTY_STATES };
